import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';


class PasswordReset extends Component {
  state = {
    token: null,
    email: null,
    password: '',
    password_confirmation: '',
    show_pass: false,
    isPopupOpen: false,
    popupMessage: '',
    submitted: false,
    statusIsOk: false
  };

  componentDidMount() {
    const pathname = window.location.pathname;
    const match = pathname.match(/\/password\/reset\/([^/]+)/);
    const token = match ? match[1] : null;

    if (!!token) {
      const email = localStorage.getItem("email");
      this.setState({ token, email });
      // this.setState({ id, expires, token, email });
      this.showPopup("");
    }
  }

  showPopup = (message) => {
    this.setState({ isPopupOpen: true, popupMessage: message });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false, popupMessage: '' });
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
      callback: {}
    });
  }

  showPass = () => {
    this.setState({ show_pass: !this.state.show_pass })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitted: true })

    const { email, token, password, password_confirmation } = this.state;

    const formToSend = new FormData();
    formToSend.append('email', email);
    formToSend.append('token', token);
    formToSend.append('password', password);
    formToSend.append('password_confirmation', password_confirmation);

    try {
      const fetchURL = process.env.REACT_APP_API_URL;
      const url = `${fetchURL}/webApi/password/reset`;

      fetch(url, {
        method: 'POST',
        headers: {
          'x-client-lang': 'en',
          'Accept': 'application/json',
        },
        body: formToSend,
      })
        .then(response => {
          if (response.status === 200) {
            this.setState({ statusIsOk: true });
          }
          return response.json();
        })
        .then(data => {
          this.setState({ submitted: false, popupMessage: data.message || data.status || data.errors?.email?.[0] || data.errors?.password?.[0] || data.errors || "No message received" });

          if (this.state.statusIsOk) { // data.message === "Done" || data.status === "Your password has been reset!"
            // setTimeout(() => {
            //   window.location.href = '/';
            // }, 3000);
          }
        })
        .catch(data => {
          this.setState({ submitted: false, popupMessage: "server_error_desc" });
        });
    } catch (error) {
      this.setState({ submitted: false, popupMessage: "server_error_desc" });
    }
  };

  render() {
    const { statusIsOk, isPopupOpen, popupMessage } = this.state;

    return (
      <div>
        {isPopupOpen && (
          <div className='popup-overlay'>

            {statusIsOk && (
              <div className='popup-popup'>

                <div className="popup_popup_bg_container">
                  <svg viewBox="0 0 790 768" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M709.195 231.079L229.302 -72.8149L97.1441 -156.481C72.6868 -171.916 44.9577 -180.026 16.7387 -180C-11.4803 -179.974 -39.1968 -171.811 -63.63 -156.331C-88.0633 -140.851 -108.354 -118.598 -122.466 -91.8047C-136.579 -65.0114 -144.017 -34.6201 -144.034 -3.67973L-144.034 771.304C-144.138 802.314 -136.769 832.804 -122.673 859.689C-108.578 886.573 -88.2559 908.899 -63.7636 924.406C-39.2712 939.913 -11.4777 948.053 16.805 948C45.0877 947.947 72.8559 939.704 97.3 924.106L203.077 857.125L348.738 764.808L709.351 536.511C733.81 521.026 754.12 498.754 768.241 471.935C782.362 445.116 789.796 414.694 789.796 383.727C789.796 352.759 782.362 322.337 768.241 295.518C754.12 268.699 733.81 246.428 709.351 230.942L709.195 231.079ZM644.738 414.243L259.021 658.472L207.661 690.988L32.6864 801.734C27.82 804.807 22.3018 806.421 16.6862 806.415C11.0707 806.408 5.55566 804.781 0.695228 801.697C-4.16521 798.613 -8.19983 794.181 -11.0031 788.846C-13.8064 783.511 -15.2796 777.461 -15.2747 771.304L-15.2747 -3.67973C-15.3332 -9.84774 -13.8793 -15.9197 -11.0652 -21.2608C-8.25097 -26.602 -4.17979 -31.0161 0.722731 -34.0417C5.63906 -37.1462 11.203 -38.8067 16.8761 -38.8627C22.4443 -38.8322 27.9033 -37.1676 32.6864 -34.0417L224.781 87.4747L644.738 353.313C649.601 356.392 653.639 360.821 656.447 366.154C659.255 371.486 660.733 377.535 660.733 383.692C660.733 389.85 659.255 395.899 656.447 401.231C653.639 406.564 649.601 410.992 644.738 414.072V414.243Z" fill="url(#paint0_linear_2298_2288)"></path>
                    <defs>
                      <linearGradient id="paint0_linear_2298_2288" x1="292.637" y1="214.052" x2="35.7033" y2="384.722" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#DA1C5C"></stop>
                        <stop offset="1" stop-color="#9E1F63"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <button className='popup-closeButton' onClick={this.closePopup}>
                  &times;
                </button>

                <div className="popup_popup_done_icon_circle">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>

                <h2 className="popup_popup_title"><FormattedMessage id="password_successfully_set" /></h2>

                <p className='popup_popup_desc'><FormattedMessage id="password_successfully_set_desc" /></p>

                <button className='popup_popup_btn' onClick={this.closePopup}>
                  <FormattedMessage id="app.enter" />
                </button>

              </div>
            )}
            {!statusIsOk && (
              <div className='popup-popup'>

                <div className="popup_popup_bg_container">
                  <svg viewBox="0 0 790 768" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M709.195 231.079L229.302 -72.8149L97.1441 -156.481C72.6868 -171.916 44.9577 -180.026 16.7387 -180C-11.4803 -179.974 -39.1968 -171.811 -63.63 -156.331C-88.0633 -140.851 -108.354 -118.598 -122.466 -91.8047C-136.579 -65.0114 -144.017 -34.6201 -144.034 -3.67973L-144.034 771.304C-144.138 802.314 -136.769 832.804 -122.673 859.689C-108.578 886.573 -88.2559 908.899 -63.7636 924.406C-39.2712 939.913 -11.4777 948.053 16.805 948C45.0877 947.947 72.8559 939.704 97.3 924.106L203.077 857.125L348.738 764.808L709.351 536.511C733.81 521.026 754.12 498.754 768.241 471.935C782.362 445.116 789.796 414.694 789.796 383.727C789.796 352.759 782.362 322.337 768.241 295.518C754.12 268.699 733.81 246.428 709.351 230.942L709.195 231.079ZM644.738 414.243L259.021 658.472L207.661 690.988L32.6864 801.734C27.82 804.807 22.3018 806.421 16.6862 806.415C11.0707 806.408 5.55566 804.781 0.695228 801.697C-4.16521 798.613 -8.19983 794.181 -11.0031 788.846C-13.8064 783.511 -15.2796 777.461 -15.2747 771.304L-15.2747 -3.67973C-15.3332 -9.84774 -13.8793 -15.9197 -11.0652 -21.2608C-8.25097 -26.602 -4.17979 -31.0161 0.722731 -34.0417C5.63906 -37.1462 11.203 -38.8067 16.8761 -38.8627C22.4443 -38.8322 27.9033 -37.1676 32.6864 -34.0417L224.781 87.4747L644.738 353.313C649.601 356.392 653.639 360.821 656.447 366.154C659.255 371.486 660.733 377.535 660.733 383.692C660.733 389.85 659.255 395.899 656.447 401.231C653.639 406.564 649.601 410.992 644.738 414.072V414.243Z" fill="url(#paint0_linear_2298_2288)"></path>
                    <defs>
                      <linearGradient id="paint0_linear_2298_2288" x1="292.637" y1="214.052" x2="35.7033" y2="384.722" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#DA1C5C"></stop>
                        <stop offset="1" stop-color="#9E1F63"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <button className='popup-closeButton' onClick={this.closePopup}>
                  &times;
                </button>

                <h2 className="popup_popup_title"><FormattedMessage id="password_reset" /></h2>

                <form onSubmit={this.handleSubmit}>
                  <div className="input-wrap">
                    <input
                      id="signup-email"
                      type='email'
                      name='email'
                      placeholder='Email'
                      value={this.state.email}
                      onChange={this.handleChange.bind(this)}
                      required
                    />
                    <label className="placeholder" htmlFor="signup-email"><FormattedMessage id="app.email" /></label>
                  </div>
                  <div className="input-wrap">
                    <input
                      id="signup-password"
                      type={(this.state.show_pass) ? 'text' : 'password'}
                      name='password'
                      placeholder='Password'
                      value={this.state.password}
                      onChange={this.handleChange.bind(this)}
                      required
                    />
                    <label className="placeholder" htmlFor="signup-password"><FormattedMessage id="app.password" /></label>
                  </div>
                  <div className="input-wrap">
                    <input
                      id="signup-password_confirmation"
                      type={(this.state.show_pass) ? 'text' : 'password'}
                      name='password_confirmation'
                      placeholder='Password again'
                      value={this.state.password_confirmation}
                      onChange={this.handleChange.bind(this)}
                      required
                    />
                    <label className="placeholder" htmlFor="signup-password_confirmation"><FormattedMessage id="app.password_confirmation" /></label>
                  </div>
                  <span className={"show_pass" + ((this.state.show_pass) ? " active" : "")} onClick={this.showPass.bind(this)}>
                    <div className="VfPpkd-YQoJzd">
                      <svg aria-hidden="true" className="VfPpkd-HUofsb" viewBox="0 0 24 24"><path className="VfPpkd-HUofsb-Jt5cK" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path></svg>
                    </div>
                    <FormattedMessage id="show_pass" />
                  </span>
                  <i className="errors_text">
                    {popupMessage === "server_error_desc" && (<FormattedMessage id="server_error_desc" />)}
                    {popupMessage !== "server_error_desc" ? popupMessage : ''}
                  </i>
                  <div className="btn-wrap">
                    <button type='submit' className={`btn ${this.state.submitted ? "submitted" : ""}`}><FormattedMessage id="app.enter" />
                      <svg width="8.574358mm" height="9.8692408mm" viewBox="0 0 8.574358 9.8692408" version="1.1">
                        <path d="M 5.5116534,2.38803 2.2173964,0.38070997 c -0.514732,-0.22305 -1.85303797,0.0172 -1.90451297,1.37683003 l -0.01288,6.31798 c -0.0025,1.22139 1.39419097,1.80501 2.17474297,1.31254 l 5.404666,-3.40994 c 0.380397,-0.24 0.627785,-1.58927 0.05564,-2.02354 L 7.5835704,3.6878" />
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.currentUser
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);